/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Features_Tab_PrecisionInputs */

const en_cad_features_tab_precision = /** @type {(inputs: Cad_Features_Tab_PrecisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precision`)
};

/**
* | output |
* | --- |
* | "Precision" |
*
* @param {Cad_Features_Tab_PrecisionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_features_tab_precision = /** @type {((inputs?: Cad_Features_Tab_PrecisionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Features_Tab_PrecisionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_features_tab_precision(inputs)
});
export { cad_features_tab_precision as "cad.features.tab_precision" }